import React, {Fragment} from 'react';
import PageTitle from '../../components/pagetitle/PageTitle';
import Navbar from '../../components/Navbar/Navbar';
import CheckoutSection from '../../components/CheckoutSection'
import Footer from '../../components/footer/Footer'
import Scrollbar from '../../components/scrollbar/scrollbar'
import { getProducts, sendReceipt } from "../../api";
import { useParams } from 'react-router-dom'
import { useState, useEffect } from 'react';


const CheckoutPage = () => {
    const [product, setProduct] = useState({});
    const [loading, setLoading] = useState(true);
    const { slug } = useParams()

    useEffect(() => {
        const fetchProduct = async () => {
            try {
                setLoading(true);
                const productsArray = await getProducts();
                const filteredProduct = productsArray.filter(product => product.slug === String(slug));
                setProduct(filteredProduct[0] || {});
            } catch (error) {
                console.error('Error fetching product:', error);
                setProduct({});
            } finally {
                setLoading(false);
            }
        };

        fetchProduct();
    }, [slug]);

    return(
        <Fragment>
            <Navbar hclass={'wpo-header-style-3'}/>
            <PageTitle pageTitle={'Checkout'} pagesub={'Checkout'}/> 
            {loading ? (
                <div style={{ textAlign: 'center', padding: '50px' }}>
                    <p>Cargando...</p>
                </div>
            ) : (
                product && Object.keys(product).length > 0 && <CheckoutSection item={product} sendReceipt={sendReceipt}/>
            )}
            <Footer footerClass={'wpo-site-footer-s2'}/>
            <Scrollbar/>
        </Fragment>
    )
};

export default CheckoutPage;
